import React, { InputHTMLAttributes, ReactNode } from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { NumberInput } from 'src/editor/shared/ui-lib/input/number-input'

interface RangeElementProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (value: number) => void
  value?: string | number
  icon?: ReactNode | string
  className?: string
  wrapperClassName?: string
  iconCLassName?: string
  min?: number
  max?: number
  allowNegative?: boolean
  label?: string
  labelIcon?: React.ReactElement | null
  itemStyles?: React.CSSProperties
  greyThumb?: boolean
  skipTranslation?: boolean
  isDecimalAllowed?: boolean
}
export const RangeElement = ({
  onChange,
  value,
  type = 'text',
  min = 0,
  max = 100,
  allowNegative,
  label,
  labelIcon = null,
  itemStyles = {},
  wrapperClassName,
  greyThumb = false,
  skipTranslation = false,
  isDecimalAllowed = false,
  ...props
}: RangeElementProps) => {
  const numericValue = Number(value) // numericValue can be NaN if value is undefined

  const percent = ((numericValue - min) / (max - min)) * 100 || 0 // 0% if value is NaN

  const isSliderWithoutValue = greyThumb || Number.isNaN(numericValue)

  const setNumberValue = (value: number | string) => {
    let val = Number(value)
    if (!allowNegative) {
      if (val < min) {
        val = min
      } else if (val > max) {
        val = max
      }
    }
    onChange(val)
  }
  return (
    <OptionWrapper
      labelClassName="mb-0.5"
      labelText={label}
      labelIcon={labelIcon}
      className={wrapperClassName || ''}
      itemStyles={itemStyles}
      skipTranslation={skipTranslation}
    >
      <div className="flex items-center gap-3">
        <input
          onChange={e => setNumberValue(Number(e.target.value))}
          value={isSliderWithoutValue ? '' : numericValue}
          type="range"
          max={max}
          min={min}
          className={`h-1.5 w-[73%] cursor-pointer appearance-none rounded-lg ${isSliderWithoutValue ? 'accent-[#ccc]' : 'accent-primary-500'} [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:bg-white ${
            isSliderWithoutValue
              ? '[&::-webkit-slider-thumb]:border-[#ccc]'
              : '[&::-webkit-slider-thumb]:border-primary-500'
          } focus:outline-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow [&::-webkit-slider-thumb]:transition-all hover:[&::-webkit-slider-thumb]:bg-btnSecondaryHover active:[&::-webkit-slider-thumb]:bg-btnSecondaryPressed`}
          style={{
            background: `linear-gradient(to right, ${
              isSliderWithoutValue ? '#ccc' : 'var(--color-primary-500)'
            } 0%, 
              ${isSliderWithoutValue ? '#ccc' : 'var(--color-primary-500)'} 
              ${percent}%, var(--color-gray-50) ${percent}%, var(--color-gray-50)  100%)`,
          }}
          {...props}
        />
        <NumberInput
          className="w-[27%]"
          onChange={onChange}
          value={numericValue}
          isDecimalAllowed={isDecimalAllowed}
          {...(allowNegative ? { min: -100, max } : { min })}
        />
      </div>
    </OptionWrapper>
  )
}
